export const scheduledJobRoutes = [
  {
    path: "/scheduledjobs",
    component: () => import("@/views/ScheduledJobs/List.vue"),
  },
];
